import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import { createStore } from "redux";
import { Provider } from "react-redux";
import reducer from "./data/reducer";
import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import './reset.css';
// import './style.css';
import './styles/output.css';

export const store = createStore(
  reducer,
  applyMiddleware(thunk)
);

export default store;

ReactDOM.render(
	<Provider store={ store }>
		<App /> 
	</Provider>,

	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js